import React, { useEffect, useState } from "react";
import api from "../axiosConfig";
import { getUser } from "../helpers";

const SchemeRowDef = (rangeValue, setRangeValue) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const user = getUser();
    if (
      rangeValue &&
      rangeValue.length === 2 &&
      rangeValue[0] &&
      rangeValue[1]
    ) {
      const startMonth = rangeValue[0].month?.number;
      const startYear = rangeValue[0].year;
      const endMonth = rangeValue[1].month?.number;
      const endYear = rangeValue[1].year;

      if (startMonth && startYear && endMonth && endYear) {
        const requestBody = {
          startMonth,
          startYear,
          endMonth,
          endYear,
          user,
          page: "scheme",
        };

        setLoading(true);

        api
          .post("/api/scheme", requestBody)
          .then((response) => {
            setData(response.data);
            setLoading(false);
          })
          .catch((error) => {
            console.error("There was an error fetching the data!", error);
            setError(error);
            setLoading(false);
          });
      } else {
        console.error("Invalid rangeValue structure");
      }
    }
  }, [rangeValue]);

  return { loading, data, error };
};

export default SchemeRowDef;
